import { jobTypeService as jobTypeServiceHQ } from 'hq/services/index';
import { useQuery } from 'react-query';
import { useSiteDetection } from 'shared/hooks';
import { jobTypeService as jobTypeServiceOGP } from 'ogp/services';
import { RequiredCertificatesForJobType } from 'ogp/services/job-type-service.types';
import { QUERY_KEYS } from 'api/query-keys';

export const useGetRequiredCertificates = (jobTypeId: string) => {
  const { isHQ, isOGP } = useSiteDetection();

  let queryFn: () => Promise<RequiredCertificatesForJobType>;

  if (isHQ) {
    queryFn = async () => await jobTypeServiceHQ.getRequiredCertificates(jobTypeId);
  } else if (isOGP) {
    queryFn = async () => await jobTypeServiceOGP.getRequiredCertificates(jobTypeId);
  } else {
    throw new Error('Site is not supported');
  }

  return useQuery(QUERY_KEYS.requiredCertificatesForJobType(jobTypeId), queryFn, {
    keepPreviousData: true,
  });
};
